import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { IInviteMessage, IReferalsState } from ".";
import { api } from "../../api/api";

interface IGetInviteMessageResponseDto extends IInviteMessage {};

export const getInviteMessage = createAsyncThunk<IGetInviteMessageResponseDto>(
    'referals/getInviteMessage',
    async () => {
        const data = await api.referals.getInviteMessage();
        return data;
    }
);

const getInviteMessageHandler = (builder: ActionReducerMapBuilder<IReferalsState>) => {
    builder
        .addCase(getInviteMessage.pending, (state) => {
            state.loading = true;
            state.error = '';
        })
        .addCase(getInviteMessage.fulfilled, (state, action: PayloadAction<IGetInviteMessageResponseDto>) => {
            state.loading = false;

            if (!action.payload)
                return;

            state.inviteMessage = action.payload;
        })
        .addCase(getInviteMessage.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message || 'Unable to get invite message';
        });
};

export default getInviteMessageHandler;